import { useRef, useState } from "react";
import { getImageUrl } from "src/Common/common";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

// Approx. height of the menu below the trigger; used to decide flip direction.
const MENU_SPACE = 70;

function DropDown({ index, onDeleteClicked, onEditClicked }) {
  const [optionShown, setOptionShown] = useState(false);
  // Open upward when there isn't room below (e.g. the last row of a scrollable
  // table, whose overflow container would otherwise clip the menu).
  const [openUp, setOpenUp] = useState(false);
  const triggerRef = useRef(null);

  const toggle = () => {
    if (!optionShown && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      // Find the nearest clipping ancestor (scrollable table body etc.); fall
      // back to the viewport bottom.
      let boundaryBottom = window.innerHeight;
      let el = triggerRef.current.parentElement;
      while (el) {
        const overflowY = window.getComputedStyle(el).overflowY;
        if (/(auto|scroll|hidden)/.test(overflowY)) {
          boundaryBottom = el.getBoundingClientRect().bottom;
          break;
        }
        el = el.parentElement;
      }
      setOpenUp(boundaryBottom - rect.bottom < MENU_SPACE);
    }
    setOptionShown((s) => !s);
  };

  return (
    <div className="relative">
      <img
        ref={triggerRef}
        onClick={toggle}
        className="cursor-pointer"
        src={getImageUrl("/images/common/options.png")}
      />
      {optionShown && (
        <OutsideClickHandler
          onOutsideClick={() => {
            setOptionShown(false);
          }}
        >
          <div
            className={`flex flex-col items-center py-1 justify-between absolute ${
              openUp ? "bottom-[25px]" : "top-[25px]"
            } left-[-5px] w-[28px] h-[54px] border-[1px] rounded-[6px] border-borderColor bg-white z-10 shadow-md`}
          >
            <img
              onClick={() => {
                onEditClicked(index);
                setOptionShown(false);
              }}
              className="w-[14px] cursor-pointer"
              src={getImageUrl("/images/common/edit.png")}
            />
            <img
              onClick={() => {
                onDeleteClicked(index);
                setOptionShown(false);
              }}
              className=" w-[14px] cursor-pointer"
              src={getImageUrl("/images/common/black_trash.png")}
            />
          </div>
        </OutsideClickHandler>
      )}
    </div>
  );
}

export default DropDown;
